import "@/globals";
import "@/setLogLevel";
import "@/registerServiceWorker";
import "@/main.css";

import { createPinia } from "pinia";
import { createApp } from "vue";

import i18n from "@/plugins/i18n-setup";
import iconsPlugin from "@/plugins/iconsPlugin";
import router from "@/router";
import { installSentry } from "@/utils/sentry";

import App from "./App.vue";

const pinia = createPinia();
const app = createApp(App);
app.use(pinia).use(i18n).use(router).use(iconsPlugin);

app.mount("#app");

installSentry();
